<div class="zakres-dat-container">
  <!-- Przycisk toggle trybu -->
  <button
    class="btn-toggle-tryb"
    [ngClass]="tryb === 'daty' ? 'btn__calender' : 'btn__grid'"
    (click)="przelaczTryb()"
    [title]="tryb === 'daty' ? 'Przełącz na wybór miesiąca' : 'Przełącz na wybór dat'"
  ></button>

  <!-- Tryb wyboru dat -->
  <div *ngIf="tryb === 'daty'" class="tryb-daty">
    <div class="pole-daty">
      <label>Od</label>
      <input type="date" [(ngModel)]="dataOd" class="input-data" />
    </div>
    <div class="pole-daty">
      <label>Do</label>
      <input type="date" [(ngModel)]="dataDo" class="input-data" />
    </div>
  </div>

  <!-- Tryb wyboru miesiąca -->
  <div *ngIf="tryb === 'miesiac'" class="tryb-miesiac">
    <button class="btn-strzalka" (click)="zmienMiesiac(-1)">
      <span class="strzalka-lewo"></span>
    </button>

    <select [(ngModel)]="wybranyRok" (change)="naZmianaRoku()" class="select-rok">
      <option *ngFor="let rok of lata" [value]="rok">{{ rok }}</option>
    </select>

    <select [(ngModel)]="wybranyMiesiac" (change)="naZmianaMiesiaca()" class="select-miesiac">
      <option *ngFor="let m of miesiace" [value]="m.id">{{ m.nazwa }}</option>
    </select>

    <button class="btn-strzalka" (click)="zmienMiesiac(1)">
      <span class="strzalka-prawo"></span>
    </button>
  </div>

  <!-- Przycisk zastosuj -->
  <button class="btn-zastosuj" (click)="zastosuj()" title="Zastosuj">
    <span class="icon-check"></span>
  </button>
</div>
